import { render, staticRenderFns } from "./phoneCmp.vue?vue&type=template&id=1d821159&scoped=true&"
import script from "./phoneCmp.vue?vue&type=script&lang=js&"
export * from "./phoneCmp.vue?vue&type=script&lang=js&"
import style0 from "./phoneCmp.vue?vue&type=style&index=0&id=1d821159&prod&scoped=true&lang=scss&"
import style1 from "./phoneCmp.vue?vue&type=style&index=1&id=1d821159&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d821159",
  null
  
)

export default component.exports